const GitHubIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="45"
			height="43"
			fill="currentColor"
			viewBox="0 0 45 43">
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M22.478.254C10.484.254.76 9.978.76 21.974c0 9.596 6.223 17.736 14.854 20.61 1.086.198 1.482-.473 1.482-1.049 0-.514-.018-1.88-.029-3.693-6.041 1.312-7.316-2.912-7.316-2.912-.988-2.508-2.412-3.176-2.412-3.176-1.972-1.348.15-1.321.15-1.321 2.18.154 3.326 2.238 3.326 2.238 1.937 3.32 5.084 2.36 6.321 1.806.198-1.404.758-2.362 1.379-2.904-4.823-.548-9.893-2.412-9.893-10.735 0-2.37.846-4.31 2.236-5.828-.224-.55-.97-2.757.212-5.748 0 0 1.824-.584 5.973 2.227a20.804 20.804 0 015.437-.73c1.844.007 3.703.248 5.438.73 4.146-2.81 5.966-2.227 5.966-2.227 1.186 2.99.44 5.199.216 5.748 1.392 1.519 2.234 3.457 2.234 5.828 0 8.344-5.079 10.18-9.918 10.717.78.671 1.475 1.996 1.475 4.023 0 2.903-.027 5.245-.027 5.957 0 .582.391 1.258 1.494 1.046 8.624-2.879 14.841-11.014 14.841-20.607 0-11.996-9.725-21.72-21.721-21.72z"
				clipRule="evenodd"></path>
		</svg>
	);
};

export default GitHubIcon;
